import { Routes, Route, Navigate } from 'react-router-dom'
import { Layout } from './components/Layout'
import { HomePage } from './pages/HomePage'
import { BudgetsPage } from './pages/BudgetsPage'
import { AuthCallback } from './pages/auth/AuthCallback'
import { LivingComplexPage } from './pages/LivingComplexPage'
import { ErrorPage } from './pages/ErrorPage'
import { EstimatePage } from './pages/EstimatePage'
import { routes, nestedRoutes } from './shared/constants/routes'

function App() {
  return (
    <Routes>
      <Route
        path={routes.root}
        element={<Navigate to={routes.complexRoot} replace />}
      />
      <Route path={routes.livingComplex()} element={<LivingComplexPage />}>
        <Route element={<Layout />}>
          <Route index element={<HomePage />} />
          <Route path={nestedRoutes.costEstimates} element={<EstimatePage />} />
          <Route path={nestedRoutes.budgets} element={<BudgetsPage />} />
        </Route>
      </Route>
      <Route path={routes.authCallback} element={<AuthCallback />} />
      <Route path={routes.error()} element={<ErrorPage />}></Route>
      <Route path="*" element={<Navigate to={routes.error('404')} replace />} />
    </Routes>
  )
}

export default App
